<template>
    <div v-if="isButtonVisible">
        <div v-if="isSparePartEnabled ? hasOnlineSparePart : ((cartmode && !HasDealer && !cartNoAccess && !data.hideCartButton) || isAddToCartBtnVisible) ">
            <button
                class="btn btn-hover btn-cart"
                :class="added ? 'btn-primary' : data.class"
                @click.prevent="addToCartWishList"
                :disabled="isDisabled"
            >{{ buttonlabel }}</button>
            <div class="modal-cart" v-show="showModal">
                <div v-if="isDisabled">
                    <h4>{{ label_adding_to_cart }}</h4>
                </div>
                <div v-if="!isDisabled">
                    <h4>{{ label_added_to_cart }}</h4>

                    <a :href="netsuite_url + 'cart'" target="_blank"
                       class="btn btn-hover btn-primary btn-cart" @click="showModal = false"
                    >{{ label_view_cart }}</a>

                    <a class="close btn btn-hover btn-primary btn-wishlist" @click.prevent="showModal = false">{{ label_continue_shopping }}</a>
                </div>
            </div>
            <div class="modal-bg" v-show="showModal"></div>
        </div>
    </div>

</template>

<script>
export default {
  name: "add-to-cart",
  props: {
    data: {},
    enable_b2c: {},
    enable_b2b: {},
    netsuite_url: {},
    netsuite_app_url: {},
    label_add_to_cart: {
      type: String,
      default: "Add to Cart"
    },
    label_added_to_cart: {
      type: String,
      default: "Added to Cart"
    },
    label_adding_to_cart: {
      type: String,
      default: "Adding to Cart"
    },
    label_view_cart: {
      type: String,
      default: "View Cart"
    },
    label_continue_shopping: {
      type: String,
      default: "Continue Shopping"
    },
    has_online_spare_part: {
      type: String,
      default: "0"
    },
    is_spare_part_enabled: {
      type: String,
      default: "0"
    },
    country: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      cartmode: false,
      isDisabled: false,
      added: false,
      currency: window.currency,
      showModal: false
    };
  },
  mounted() {
    var enables = new Object();
    enables["enable_b2b"] = this.enable_b2b;
    enables["enable_b2c"] = this.enable_b2c;

    if (this.data.netSuiteId) {
      this.$store
        .dispatch("auth/isCartMode", enables)
        .then(data => {
        //   console.log("enable_b2b", this.enable_b2b);
        //   console.log("enable_b2c", this.enable_b2c);
        //   console.log("isCartMode", data);
          this.cartmode = data;
        })
        .catch(error => {});
    }
  },
  methods: {
    setCartCount(count) {
      this.$store.commit("wishlist/setCartCount", count);
    },
    addItemTocart(items) {
      if(items && items.length) items.reverse();
      console.log('addItemTocart', items)
      this.isDisabled = true;
      let vm = this;

      var data = [];
      for(var i = 0; i < items.length; i++) {
        if (this.data && this.data.quantity) {
          items[i].qty = items[i].qty * this.data.quantity;
        }
        data.push(
          items[i].isPackage
            ? this.ProductData(
                items[i].netSuiteId,
                items[i].qty,
                "NonInvtPart",
                items[i].hasPackages
              )
            : this.ProductData(items[i].netSuiteId, items[i].qty, "Assembly", items[i].hasPackages)
        );
      }

      jQuery
        .ajax({
          url: this.addToCartUrl,
          method: "POST",
          data: JSON.stringify(
            data
          ),
          xhrFields: {
            withCredentials: true
          }
        })
        .done(function(res) {
          if (res.errorMessage) {
            alert(
              "Adding this item caused an error",
            );
            console.log("Error response", res);
          } else {
            let qtys = res.lines.map(obj => {
              return obj.quantity;
            });

            vm.setCartCount(eval(qtys.join("+")));
          }
          vm.isDisabled = false;
          vm.added = true;
          for(var i = 0; i < items.length; i++) {
              if (items[0].isPackage) vm.$emit("removeFromWishlist", vm.data.stockCode);
          }
        })
        .fail(function(err) {
          alert("An error has occurred adding to cart");
          vm.isDisabled = false;
          console.log(err.responseJSON);
        });
    },
    addToCartWishList() {
      this.showModal = true;
      let vm = this;

      jQuery
        .ajax({
          url: vm.getPackageComponentsUrl,
          method: "GET",
          xhrFields: {
            withCredentials: true
          }
        })
        .done(function(res) {
          if (res.success === true) {
            // console.log("getPackageComponentsUrl", res.data);
            var cartItems = [];
            if (res.data.length) {
              if (!vm.data.netSuiteId) {
                alert("cant add this -> no netSuiteId");
              } else {
                cartItems.push({netSuiteId: vm.data.netSuiteId, qty: 1, isPackage: true, hasPackages: true});
              }

              res.data.forEach(function(PackageComponent) {
                cartItems.push({netSuiteId: PackageComponent.netSuiteId, qty: PackageComponent.qty, isPackage: null, hasPackages: true});
              });
            } else {
              if (!vm.data.netSuiteId) {
                alert("cant add this -> no netSuiteId");
              } else {
                cartItems.push({netSuiteId: vm.data.netSuiteId, qty: 1, isPackage: true, hasPackages: false});
              }
            }

            vm.addItemTocart(cartItems);
          }
        })
        .fail(function(err) {
          alert("An error has occurred adding to cart");
          vm.isDisabled = false;
          console.log(err.responseJSON);
        });
    },
    ProductData(
      netSuiteId = null,
      quantity = 1,
      type = "Assembly",
      hasPackages = null
    ) {
      var product = new Object();
      product["internalid"] = netSuiteId ? netSuiteId : this.data.netSuiteId;
      product["type"] = type;

      var item = new Object();
      item["item"] = product;
      item["quantity"] = quantity;
      if (hasPackages == true)
        item["options"] = [
          {
            cartOptionId: "custcol_rr_pmisca",
            itemOptionId: "",
            label: "PMISCA",
            type: "text",
            value: {
              internalid: '' + this.data.netSuiteParentId+ '',
              label: '"' + this.data.netSuiteParentId + '"'
            }
          }
        ];
      else item["options"] = [];
      item["location"] = "";
      item["fulfillmentChoice"] = "ship";
      item["freeGift"] = false;

      return item;
    }
  },
  computed: {
    HasDealer() {
      return this.dealer_set == "1" ? true : false;
    },
    cartNoAccess() {
      return this.$store.getters["auth/cartNoAccess"];
    },
    addToCartUrl() {
      return (
        this.netsuite_app_url +
        "services/LiveOrder.Line.Service.ss?c=" + (window.ns_session_var ? window.ns_session_var : "") + "&n=2"
      );
    },
    getPackageComponentsUrl() {
      return (
        (window.culture ? "/" + window.culture : "") +
        "/api/getPackageComponents/" +
        this.data.productId
      );
    },
    buttonlabel() {
      return !this.added
        ? this.label_add_to_cart
        : this.label_added_to_cart;
    },
    isAddToCartBtnVisible() {
        return this.$store.getters['outofstock/isAddToCartBtnVisible'];
    },
    isSparePartEnabled() {
      return Boolean(Number(this.is_spare_part_enabled));
    },
    hasOnlineSparePart() {
      return Boolean(Number(this.has_online_spare_part));
    },

    isButtonVisible() {
      let components, netSuiteId, isAlwaysInStock;
      if(this.apiData) {
          components = this.apiData.data.items;
          netSuiteId = this.data.netSuiteId;
          isAlwaysInStock = this.data.isAlwaysInStock;
          return this.$store.getters["cart/isAddToCartButtonVisible"](components, netSuiteId, isAlwaysInStock);
      }

      return false;
    },

  }
};
</script>

<style>
.modal-cart {
  background: #fff;
  width: 300px;
  height: auto;
  text-align: center;
  position: fixed;
  top: 50%;
  margin-top: -50px;
  left: 50%;
  margin-left: -100px;
  line-height: 25px;
  z-index: 100001;
  padding: 15px;
}
.modal-cart .close,
.modal-cart .close:hover {
  cursor: pointer;
}
.modal-bg {
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  filter: alpha(opacity=20);
  zoom: 1;

  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
}
</style>
